"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a list of all logs.
 *
 * ### Sort options
 *
 * - `date` - sorts by date of log.
 *
 * ## Usage
 *
 * ```ts
 * const logsAll: Log[] = await sdk.getLogList({ });
 * const logsNewest: Log[] = await sdk.getLogList({ sort: { date: 'desc' }});
 * const logsComplete: Log[] = await sdk.getLogList({ filter: { type: LogType.COMPLETE }});
 * ```
 *
 * @param params.filter - Filter to apply to returned log list.
 * @param params.sort - Fields to sort log list by.
 * @param params.limit - Limit how many logs you want to have returned (sorted from newest).
 */
const getLogList = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { filter, sort, limit } = params;
    const url = `${BASE_URL}/logs/list`;
    const logResponse = yield axios_1.default.post(url, { filter, sort, limit }, { validateStatus: () => true });
    const { status, data } = logResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getLogList = getLogList;
